import React from 'react';

import { faOtter } from '@fortawesome/pro-regular-svg-icons';
import { Button } from 'components/ui/button';

interface Props {
  onClick: () => void;
}

export default function AssistantLauncher({ onClick }: Props) {
  return (
    <div className="position-fixed top-50 translate-middle-y" style={{ right: '0.75rem', zIndex: 1045 }}>
      <Button
        className="rounded-circle shadow"
        icon={faOtter}
        tooltip="Ask Otto"
        tooltipPlacement="left"
        onClick={onClick}
      />
    </div>
  );
}
